<template>
    <div class="hello">
        <div class="box member-index">
            <div class="box-header box-clearfix">
                <div class="box-title box-top clearfix">
                    <el-button :class="{'box-top-artive':user_type==1}" @click="user_type_tap(1)">Zeal Standard Trading
                        Account
                    </el-button>
                    <el-button :class="{'box-top-artive':user_type==2}" @click="user_type_tap(2)">Zeal ECN Trading
                        Account
                    </el-button>
                    <div class="search-view">
                        <input type="text" v-model="search_product">
                        <i class="iconfont icon-sousuo" @click="search_product_event"></i>
                    </div>
                </div>
            </div>
            <div class="box-body">
                <div class="member-content-view">
                    <ul class="header-nav clearfix">
                        <li :class="{active:item.key===products_type_list_curr}" v-for="item in products_type_list"
                            @click="product_tap_event(item.key)">{{item.title}}
                        </li>
                    </ul>

                    <div class="ix-table-view">
                        <div class="kx-table">
                            <div class="kx-table-top clearfix">
                                <div class="item">Symbol</div>
                                <div class="item">Sell</div>
                                <div class="item">Buy</div>
                                <div class="item">High/Low</div>
                                <div class="item"></div>
                            </div>

                            <div class="kx-table-content ">
                                <div v-for="(item,key,index) in products_list" ref="list_item"
                                     :class="{active:item.symbol===symbol}">
                                    <div class="clearfix">
                                        <div class="item item-first" @click="tap_k_line(item.symbol,index)"
                                             :class="{active:item.symbol===symbol}">
                                            {{item.symbol_mt4}}
                                        </div>
                                        <div class="item" v-html="item.price.sell_show"></div>
                                        <div class="item" v-html="item.price.buy_show"></div>
                                        <div class="item" v-html="item.price.high_show+'/'+item.price.low_show">
                                        </div>
                                        <div class="item">
                                            <i @click="chart_info(item,index)" class="iconfont icon-i-info"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="k-line-view" :style="{'top':k_line_view_top+'px'}" ref="k_line_content">
                            <!--图表内容区域，必须给 ECharts 容器本身指定高度。不然它会使用默认高度-->
                            <i class="iconfont icon-xiangshangjiantou close" @click="clone_k_line"></i>
                            <div class="chart" v-show="symbol">
                                <div id="echarts" style="height: 17.5rem"></div>
                            </div>

                            <ul class="chart-footer clearfix">
                                <li class="chart-item" v-for="item in chart_item" @click="chart_item_event(item)"
                                    :class="{active:item===chart_interval}">{{item}}
                                </li>
                                <li class="chart-icon" @click="chart_btn"><i
                                        :class="{iconfont:true,'icon-Kxiantu':chart_tap,'icon-tubiao-zhexiantu':!chart_tap}"></i>
                                </li>
                            </ul>
                        </div>

                    </div>

                </div>

            </div>
        </div>

        <el-dialog
                title=""
                :visible.sync="chartDialogVisible"
                width="480px"
                :modal="false"
                custom-class="chart-dialog"
        >
            <div class="chart-dialog-view" v-if="curr_chart_info.price">
                <h3 class="top-text">{{curr_chart_info.symbol_mt4}}</h3>
                <p class="dollar">{{curr_chart_info.name}}</p>
                <ul class="sell-or-buy clearfix">
                    <li :class="{
            'rise':(products_info.symbol_prices.sell>products_info.symbol_prices_old.sell),
            'dorp':(products_info.symbol_prices.sell<products_info.symbol_prices_old.sell)
            }"><p> Sell</p>
                        <p v-html="products_info.symbol_prices.sell_show"></p></li>
                    <li
                            :class="{
            'rise':(products_info.symbol_prices.buy>products_info.symbol_prices_old.buy),
            'dorp':(products_info.symbol_prices.buy<products_info.symbol_prices_old.buy)
            }"
                    ><p> buy</p>
                        <p v-html="products_info.symbol_prices.buy_show"></p></li>
                </ul>
                <div class="traders">
                    <h2><i class="iconfont icon-htmal5icon03"></i>Traders' Sentiments</h2>
                    <div class="progress"><i :style="{width:products_info.seller_buyer.buyer+'%'}"></i></div>
                    <div class="progress-foot-text"><span
                            class="left">{{products_info.seller_buyer.buyer}}% Buyers</span><span class="right">{{products_info.seller_buyer.seller}}% Sellers</span>
                    </div>
                </div>
                <div class="info">
                    <h2><i class="iconfont icon-htmal5icon03"></i> info</h2>
                    <ul class="info-top clearfix">
                        <li><p>{{curr_chart_info.contract_size}}</p><strong>Contract Size per Standard Lot</strong></li>
                        <li><p>{{curr_chart_info.max_leverage}}</p><strong>Maximum Leverage</strong></li>
                        <li><p>{{curr_chart_info.spread}}%</p><strong>Minimum Spread</strong></li>
                    </ul>
                    <ul class="info-view">
                        <li class="clearfix"><p>Commission(USD/Standard Lot)</p>
                            <strong>{{curr_chart_info.commisssion}}</strong></li>
                        <li class="clearfix"><p>Overnight Funding - Long</p>
                            <strong>{{curr_chart_info.overnight_long}}</strong></li>
                        <li class="clearfix"><p>Overnight Funding - Short</p>
                            <strong>{{curr_chart_info.overnight_short}}</strong></li>
                        <li class="clearfix"><p>Minimum Initial Margin</p>
                            <strong>{{curr_chart_info.minimun_margin}}</strong></li>
                        <li class="clearfix"><p>Maintenance Margin</p>
                            <strong>{{curr_chart_info.maintenance_margin}}</strong></li>
                        <li class="clearfix"><p>Hedged Position Margin Requirement</p><strong>{{curr_chart_info.hedged_margin}}</strong>
                        </li>
                        <li class="clearfix"><p>Expiry Date</p><strong>{{curr_chart_info.expiry_date}}</strong></li>
                        <li class="clearfix"><p>Minimum Stop Loss/Limit Order Distance</p><strong>{{curr_chart_info.mininum_stop_loos}}</strong>
                        </li>
                        <li class="clearfix"><p>Minimum Trade Size in Standard Lot</p><strong>{{curr_chart_info.mini_trade_size}}</strong>
                        </li>
                        <li class="clearfix"><p>Maximum Trade Size per Order in Standard Lots</p><strong>{{curr_chart_info.maxmun_trade_size}}</strong>
                        </li>
                        <li class="clearfix"><p>Trading Sessions</p><strong>{{curr_chart_info.trading_session}}</strong>
                        </li>
                    </ul>
                </div>
            </div>
            <span slot="footer" class="dialog-footer"> </span>
        </el-dialog>

    </div>
</template>

<script>
import echarts from 'echarts/lib/echarts'
import 'zrender/lib/svg/svg'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/candlestick'
import chartUtil from '../../utils/chartUtil'
import io from 'socket.io-client'
import KLineItem from './KLineItem'
import { toFixedData } from '../../utils/index'

export default {
  name: 'quotation',
  data() {
    return {
      chart: null,
      chart_tap: true,
      chart_interval: '1wk',
      chart_item: [
        '1m',
        '2m',
        '5m',
        '15m',
        '30m',
        '60m',
        '90m',
        '1h',
        '1d',
        '5d',
        '1wk'
      ],
      search_product: '',
      products_list: {},
      products_type_list_curr: 0,
      products_type_list: [
        {
          key: 0,
          title: 'The Most Popular'
        },
        {
          key: 1,
          title: 'FX'
        },
        {
          key: 2,
          title: 'Commodities'
        },
        {
          key: 3,
          title: 'Indices'
        },
        {
          key: 4,
          title: 'Crypto'
        }
      ],
      data_list: [],
      socket: '',
      symbol: 'EURUSDe',
      symbol_info: '',
      chartDialogVisible: false,
      curr_chart_info: {},
      products_info: {},
      user_type: 2,
      k_line_view_top: 0,
      k_line_view_left: 0
    }
  },
  mounted() {
    // 初始化 ECharts 实例，不能在created生命周期内初始化，因为那时候DOM还没有渲染，是找不到元素的
    const that = this
    this.socket = io('https://my.zfx.co.uk:3210')
    // 连接后登录
    this.socket.on('connect', function() {
      // 连接成功后，需要提交登录，附带上产品symbol
      that.products_emit()
    })
    // 后端推送来通知消息（错误提示）
    this.socket.on('msg', function(msg) {
      console.log('msg:', msg)
    })
    // 后端推送来的K线图数据
    this.socket.on('data', function(data) {
      that.data_list = data
      that.initChart()
    })
    this.socket.on('product', function(data) {
      console.log('+++++++products_info', data)
      console.log('+++++++++toFixedSymbol', that.symbol)
      data = toFixedData(data, that.user_type, true, that.symbol)
      data.symbol_prices.buy_show = that.numberFloor5Str(data.symbol_prices.buy)
      data.symbol_prices.sell_show = that.numberFloor5Str(
        data.symbol_prices.sell
      )

      that.products_info = data
    })
    this.socket.on('products', function(data) {
      // console.log('data,that.user_type',data,that.user_type)
      data = toFixedData(data, that.user_type)
      // 数据显示样式
      var arr = ['sell', 'buy', 'high', 'low']
      arr.forEach(ele => {
        console.log(data)
        for (let key in data) {
          data[key].price[ele + '_show'] = that.numberFloor5Str(
            data[key].price[ele]
          )
        }
      })
      // console.log('data_show', data.price)
      that.products_list = data
      /*  that.symbol = Object.keys(that.products_list)[0] */
      that.socket_chart_subscriber()
      console.log('that.products_list', data)
    })

    /*var myDiv = document.querySelector('.k-line-view')

        document.addEventListener('click', function () {
          let arr = event.target.classList
          console.log('arr', arr.value)
          if (arr.value.indexOf('item-first') === -1) {
            that.$refs.k_line_content.classList.remove('active')
          }
        })

        myDiv.addEventListener('click', function (event) {
          event = event || window.event
          event.stopPropagation()
        })*/
  },
  beforeDestroy() {
    // 组件销毁前先销毁 ECharts 实例
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      // 基于准备好的dom，初始化echarts实例,移动端建议使用 svg模式
      this.chart = echarts.init(document.getElementById('echarts'), 'light', {
        renderer: 'svg'
      })
      this.chart.setOption(chartUtil.candleOption(this.data_list))

      // 图标根据窗口大小自动缩放
      // window.addEventListener("resize", this.chart.resize);
    },
    chart_item_event(val) {
      this.chart_interval = val
      this.socket_chart_subscriber()
    },
    socket_chart_subscriber() {
      console.log('this.symbol', this.symbol)
      this.socket.emit('subscriber', {
        symbol: this.symbol,
        period1: 1533888219, // 可选，暂时没作用
        period2: 1533889219, // 可选，暂时没作用
        interval: this.chart_interval // 可选，暂时没作用
      })
    },
    products_emit() {
      this.socket.emit('products', {
        user_type: this.user_type,
        symbol: this.search_product,
        type: this.products_type_list_curr // 可选，暂时没作用
      })
    },
    product_tap_event(val) {
      this.products_type_list_curr = val
      this.clone_k_line()
      this.products_emit()
    },
    user_type_tap(val) {
      this.user_type = val
      this.products_emit()
    },
    search_product_event() {
      this.products_emit()
    },
    tap_k_line(val, key) {
      console.log(val, key)
      this.$refs.k_line_content.classList.add('active')
      this.k_line_view_top = (key + 1) * 38 + 68
      this.symbol = val
      this.initChart()
      this.socket_chart_subscriber()
    },
    clone_k_line() {
      this.$refs.k_line_content.classList.remove('active')
      this.symbol = ''
    },
    chart_info(val, index) {
      console.log('val', val)
      this.tap_k_line(val.symbol, index)
      this.symbol = val.symbol
      this.curr_chart_info = val
      this.socket_chart_subscriber()
      this.chartDialogVisible = true
    },
    chart_btn() {
      this.chart_tap = !this.chart_tap
      if (this.chart_tap) {
        this.chart.setOption(chartUtil.candleOption(this.data_list))
      } else {
        this.chart.setOption(chartUtil.lineOption(this.data_list))
      }
    },
    numberFloor5Str(value) {
      var str = String(value)
      var result =
        str.substring(0, str.length - 1) +
        '<span>' +
        str.substring(str.length - 1) +
        '</span>'
      return result
    }
  },
  filters: {
    toFixedInt(val) {
      /* return val.toFixed(2) */
      return parseInt(val * 100000) / 100000
    },
    numFilter(value) {
      // 截取当前数据到小数点后三位
      let transformVal = Number(value).toFixed(3)
      let realVal = transformVal.substring(0, transformVal.length - 1)
      // num.toFixed(3)获取的是字符串
      return Number(realVal)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.member-index {
  .box-top {
    button {
      border-radius: 0px;
    }
    .box-top-artive {
      background: #0A95FF;
      border-color: #0A95FF;
      color: #fff;
    }
    .search-view {
      float: right;
      position: relative;
      input {
        width: 400px;
        height: 38px;
        border: solid 1px #cccccc;
        padding: 0 40px 0 10px;
      }
      i {
        position: absolute;
        cursor: pointer;
        right: 0px;
        width: 40px;
        text-align: center;
        line-height: 39px;
        height: 40px;
      }
    }
  }
  .member-content-view {
    .header-nav {
      margin-bottom: 20px;
      li {
        width: 192px;
        text-align: center;
        height: 38px;
        font-size: 14px;
        color: #333;
        cursor: pointer;
        line-height: 38px;
        float: left;
        margin-right: 4px;
        background: #f2f2f2;
        &:last-of-type {
          margin-right: 0;
        }
        &.active {
          background-color: #0A95FF;
          color: #fff;
        }
      }
    }
    .ix-table-view {
      position: relative;
      .kx-table {
        position: relative;
        z-index: 1000;
        .kx-table-top {
          margin-bottom: 20px;
          .item {
            float: left;
            display: block;
            width: (10/5) * 10%;
            text-align: center;
            font-size: 14px;
            font-weight: bold;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #333333;
            height: 45px;
            line-height: 45px;
            background: #fff;
            border-bottom: 3px solid #ddd;
            &:nth-of-type(2n) {
              border-bottom: 3px solid #f2f2f2;
            }
          }
        }
        .kx-table-content {
          border-top: solid 1px #dddddd;
          border-right: solid 1px #dddddd;
          .active {
            &:after {
              content: '';
              height: 420px;
              display: block;
            }
          }
          .item {
            float: left;
            display: block;
            width: (10/5) * 10%;
            text-align: center;
            height: 38px;
            line-height: 38px;
            border-left: solid 1px #dddddd;
            border-bottom: solid 1px #dddddd;
            &:first-child {
              cursor: pointer;
            }
            .icon-i-info {
              color: #0A95FF;
              font-size: 20px;
              cursor: pointer;
            }
            span {
              font-size: 12px;
              line-height: 33px;
              vertical-align: top;
            }
          }
        }
      }
      .k-line-view {
        position: absolute;
        width: 100%;
        top: 113px;
        left: 0;
        background: #fff;
        border-radius: 4px;
        border: 1px solid #ebeef5;
        padding: 12px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        z-index: 999;
        opacity: 0;
        .close {
          width: 35px;
          text-align: center;
          cursor: pointer;
          height: 35px;
          border-radius: 5px;
          line-height: 35px;
          border: 1px solid #e0e0e0;
          display: block;
        }
        &.active {
          opacity: 1;
          z-index: 1111;
        }
      }
    }
  }
}

.chart-footer {
  border: 1px solid #e0e0e0;
  border-right: none;
  width: 100%;
  margin-top: 30px;
  li {
    display: block;
    float: left;
    width: (10/12) * 10%;
    border-right: 1px solid #e0e0e0;
    text-align: center;
    line-height: 40px;
    font-size: 14px;
    cursor: pointer;
    color: #666;
    &.chart-icon {
      font-size: 18px;
    }
    &.active {
      background: #0A95FF;
      color: #fff;
    }
  }
}

.chart-dialog {
  left: 398px;
  border: 1px solid #0A95FF;
  .el-dialog__header {
    background: #0A95FF;
    height: 40px;
    padding: 0;
    font-size: 0;
  }
  .el-dialog__headerbtn {
    top: 5px;
    right: auto;
    left: 10px;
    color: #fff;
    font-size: 22px;
    i {
      color: #fff;
    }
    &:hover {
      i {
        color: #f3f3f3;
      }
    }
  }
  .el-dialog__body {
    padding: 0;
  }
  .chart-top {
    height: 40px;
    text-align: center;
    background-color: #f2f2f2;
    line-height: 40px;
  }
  .chart-dialog-view {
    padding: 20px;
    .top-text {
      font-weight: bold;
      color: #333333;
      strong {
        float: right;
        color: #0dc000;
      }
    }
    .dollar {
      padding: 15px 0 10px;
    }
    .sell-or-buy {
      li {
        float: left;
        width: 216px;
        height: 50px;
        border: solid 1px #83c6e5;
        text-align: center;
        padding-top: 2px;
        color: #333;
        font-weight: bold;
        &:nth-child(2) {
          margin-left: 5px;
        }
        &.rise {
          background: #0c8a37;
          border-color: #0c8a37;
          color: #fff;
        }
        &.dorp {
          background: #bf0000;
          border-color: #bf0000;
          color: #fff;
        }
        span {
          display: inline-block;
          line-height: 1;
          font-size: 12px;
          vertical-align: top;
          padding-top: 2px;
        }
      }
    }
    .traders {
      h2 {
        font-size: 14px;
        line-height: 18px;
        font-weight: bold;
        margin-top: 25px;
        color: #333333;
        i {
          font-size: 14px;
          margin-right: 10px;
        }
      }
      .progress {
        margin-top: 10px;
        margin-bottom: 3px;
        height: 20px;
        width: 100%;
        background: #bf0000;
        position: relative;
        i {
          position: absolute;
          left: 0;
          top: 0;
          height: 20px;
          background: #0a9200;
        }
      }
      .progress-foot-text {
        .left {
          float: left;
          color: #0a9200;
        }
        .right {
          float: right;
          color: #bf0000;
        }
      }
    }
    .info {
      margin-top: 40px;
      h2 {
        font-size: 14px;
        line-height: 18px;
        font-weight: bold;
        margin-top: 25px;
        color: #333333;
        i {
          font-size: 14px;
          margin-right: 10px;
        }
      }
      .info-top {
        margin-top: 20px;
        li {
          width: 33.33%;
          float: left;
          text-align: center;
          strong {
            color: #999999;
            font-weight: normal;
          }
        }
      }
      .info-view {
        li {
          padding-bottom: 5px;
          margin-top: 15px;
          border-bottom: dashed 1px #cccccc;
          p {
            float: left;
          }
          strong {
            float: right;
          }
        }
      }
    }
  }
}
</style>
